export default (getView) => (nextStepPath) => ({
  ...getView(nextStepPath),

  formValues: {
    gender: null,
    firstMealAfter: null,
    hormonalContraceptions: null,
    bonePain: null,
    fallingAsleep: null,
  },
})
